const fonts = {
  header: { fontFamily: '"Inter", Roboto, Arial, sans-serif' },
  text: { fontFamily: '"Inter", Roboto, Arial, sans-serif' },
  button: { fontFamily: '"Inter", Roboto, Arial, sans-serif' }
};

export default fonts;
